import Finance from "@/pages/finance/Finance";

// Wrapper for "Receivables" - reuses the rich Finance UI which is AR-centric.
export default function FinanceReceivables() {
  return <Finance />;
}
